/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccount = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 2h10.414L22 7.586V22h-6v-2h4V9h-5V4H8v2H6zm11 3.414V7h1.586zM5.85 12h4.3L8 10.28zm1.525-3.78a1 1 0 0 1 1.25 0l5 4A1 1 0 0 1 13 14H3a1 1 0 0 1-.625-1.78zM3 18.95V15h2v3.95zm4 0V15h2v3.95zm4 0V15h2v3.95zM2 22v-2h12v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAccount as Account };
